import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Card,
} from "@mui/material";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzDaySelectButton from "src/components/core-components/mui/ByzDaySelect";
import { useTranslate } from "src/locales";

const OtherButtons: React.FC = () => {
  const { t } = useTranslate();
  return (
    <Card sx={{ mb: 3 }}>
      <ByzMuiTypography variant="h3" sx={{ borderBottom: "1px solid #E0E0E0" }}>
        Diğer Butonlar
      </ByzMuiTypography>
      <TableContainer sx={{ maxWidth: "100%" }}>
        <Table aria-label="simple table" size="small" stickyHeader>
          <TableBody>
            <TableRow>
              <TableCell>
                <Box sx={{ width: "350px", margin: "20px auto" }}>
                  <ByzDaySelectButton
                    previousText={t("patient-care.previous-day")}
                    todayText={t("patient-care.today")}
                    nextText={t("patient-care.next-day")}
                  />
                </Box>
              </TableCell>
              <TableCell>
                <ByzMuiTypography variant="h6">
                  ByzDaySelectButton
                </ByzMuiTypography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default OtherButtons;
